import { userService } from 'common/utils/user-service';
export var RequiredAuth = function (_a) {
    var children = _a.children;
    if (userService.isLoggedIn()) {
        return children;
    }
    userService.doLogin();
    return null;
};
